import { VERTICAL_EMBED_TYPE } from "./../../ricos-content/index.js";
import { changeBaseUrl } from "./changeBaseUrl.js";
function verticalEmbedViewerStrategy(baseUrl, disabled = false) {
  return {
    config: {
      [VERTICAL_EMBED_TYPE]: {
        changeBaseUrl: (url) => changeBaseUrl(url, baseUrl),
        disabled
      }
    }
  };
}
export {
  verticalEmbedViewerStrategy
};
//# sourceMappingURL=verticalEmbedViewerStrategy.js.map
